// Sample data based on the schemas
export function getSampleData() {
  return {
    "patient.admit": {
      meta: {
        type: "patient.admit" as const,
        messageId: "msg-123",
        whenGenerated: new Date().toISOString(),
      },
      payload: {
        url: "https://api.example.com/webhook",
        patientId: "patient-123",
        externalId: "ext-456",
        additionalIds: {
          mrn: ["MRN001"],
          encounter: ["ENC001"],
        },
        admitTimestamp: new Date().toISOString(),
        whenSourceSent: new Date().toISOString(),
      },
    },
    "patient.transfer": {
      meta: {
        type: "patient.transfer" as const,
        messageId: "msg-124",
        whenGenerated: new Date().toISOString(),
      },
      payload: {
        url: "https://api.example.com/webhook",
        patientId: "patient-123",
        externalId: "ext-456",
        additionalIds: {
          mrn: ["MRN001"],
          encounter: ["ENC001"],
        },
        admitTimestamp: new Date(Date.now() - 3600000).toISOString(), // 1 hour ago
        transfers: [
          {
            timestamp: new Date().toISOString(),
            sourceLocation: {
              name: "Emergency Room",
              type: "ER",
            },
            destinationLocation: {
              name: "Medical Ward 3",
              type: "WARD",
            },
          },
        ],
        whenSourceSent: new Date().toISOString(),
      },
    },
    "patient.discharge": {
      meta: {
        type: "patient.discharge" as const,
        messageId: "msg-125",
        whenGenerated: new Date().toISOString(),
      },
      payload: {
        url: "https://api.example.com/webhook",
        patientId: "patient-123",
        externalId: "ext-456",
        additionalIds: {
          mrn: ["MRN001"],
          encounter: ["ENC001"],
        },
        admitTimestamp: new Date(Date.now() - 86400000).toISOString(), // 1 day ago
        dischargeTimestamp: new Date().toISOString(),
        whenSourceSent: new Date().toISOString(),
      },
    },
  };
}
